import styled from 'styled-components/macro'

import { Layout, Select, type SelectProps, Text } from '@loadsmart/loadsmart-ui'
import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import { type ExhaustiveArrayOfObject } from 'core/utils/type'

import { screen } from 'legacy/styles/screen'

import { type SortBy } from '../../domain/SortBy'

type SelectValue = SelectProps['value']

export type Option = {
  label: string
  value: SortBy
}

export const SORT_OPTIONS: ExhaustiveArrayOfObject<SortBy, Option> = [
  {
    label: 'Sort by lane',
    value: 'lane',
  },
  {
    label: 'Sort by deadline',
    value: 'deadline',
  },
]

const Header = styled(Layout.Group)`
  background-color: ${getToken('color-neutral-lightest')};

  ${screen.md} {
    padding: ${getToken('space-m')} 0;
    position: sticky;
    top: 0;
    z-index: 1;
  }
`

export type BulkSpotQuoteTabHeaderProps = {
  header: string
  sortBy: SortBy
  onSortChange: (value: SortBy) => void
  suffix?: React.ReactNode
}

export function BulkSpotQuoteTabHeader({
  header,
  sortBy,
  onSortChange,
  suffix,
}: BulkSpotQuoteTabHeaderProps) {
  const value = SORT_OPTIONS.find(option => option.value === sortBy)

  return (
    <Header align="center" space="xl" justify="space-between">
      <Layout.Group space="xl">
        <Text variant="heading-md-bold">{header}</Text>
      </Layout.Group>
      <Layout.Group space="xl">
        <Select
          id="bulk-quote-sort"
          name="bulk-quote-sort"
          options={SORT_OPTIONS}
          value={value as SelectValue}
          onChange={event => onSortChange((event.target.value as Option).value)}
          hideClear
        />
        {suffix}
      </Layout.Group>
    </Header>
  )
}
